import { swRequest } from "./sw-request";
import { isExtension } from "./env";
import { uuidV4 } from "./uuidV4";

const { host, pathname } = window.location;

let sessionKey = null;
export const getSessionKey = () => {
  if (sessionKey) return sessionKey;

  sessionKey = sessionStorage.getItem("sessionKey");
  if (!sessionKey) {
    sessionKey = uuidV4();
    sessionStorage.setItem("sessionKey", sessionKey);
  }
  return sessionKey;
};

const WEB_SOCKET_LISTENERS = [];

let WEBSOCKET = null;

const initializeWebsocket = async () => {
  if (WEBSOCKET) return;

  if (isExtension()) {
    WEBSOCKET = await diallerExtensionWebsocket();
  } else {
    WEBSOCKET = new WebSocket(
      `wss://${host}/socket?pathname=${pathname}&sessionKey=${getSessionKey()}`,
    );

    const onClose = () => {
      WEBSOCKET = null;
      initializeWebsocket();
    };

    WEBSOCKET.addEventListener("error", () => {
      WEBSOCKET.close();
    });

    WEBSOCKET.addEventListener("close", () => {
      setTimeout(onClose, 3000);
    });

    WEB_SOCKET_LISTENERS.forEach(({ listener, type }) => {
      WEBSOCKET.addEventListener(type, (event) => {
        if (type === "message") listener(JSON.parse(event.data));
        else listener(event);
      });
    });
  }
};

export const addWebsocketListener = (listener, type = "message") => {
  initializeWebsocket();
  WEB_SOCKET_LISTENERS.push({ listener, type });

  // If WEBSOCKET is already initialized, add the listener immediately
  if (WEBSOCKET) {
    WEBSOCKET.addEventListener(type, (event) => {
      if (type === "message") listener(JSON.parse(event.data));
      else listener(event);
    });
  }
  // Otherwise, it will be added when setupWebsocketListeners is called
};

const diallerExtensionWebsocket = async () => {
  try {
    const res = await swRequest({
      path: `/api/extension/get_websocket_state`,
      method: "GET",
    });
    return new WebSocket(
      `wss://sourcewhale.app/socket?pathname=dialler&state=${res.state}`,
    );
  } catch {
    console.error("Error initializing dialler extension websocket");
    return null;
  }
};

export const sendInboundCallResponse = (conversationId, diallerStatus) => {
  if ([undefined, ""].includes(conversationId)) return;
  if (!WEBSOCKET) return;
  WEBSOCKET.send(
    JSON.stringify({
      action: "sendMessage",
      message: { conversationId, messageObj: { diallerStatus } },
    }),
  );
};
